// assets
import { AppSettingsAlt, Mail } from '@mui/icons-material';

// constant
const icons = { AppSettingsAlt, Mail };

// ==============================|| MANAGE MENU ITEMS ||============================== //

const manage = {
    id: 'manage',
    title: 'Manage',
    type: 'group',
    children: [
        {
            id: 'forceUpdate',
            title: 'Force Update',
            type: 'item',
            url: '/manage/forceUpdate',
            icon: icons.AppSettingsAlt,
            authority: 'INFRA_VIEW'
        },
        {
            id: 'mail',
            title: 'Mail',
            type: 'item',
            url: '/manage/mail',
            icon: icons.Mail,
            authority: 'MAIL_SEND'
        }
    ]
};

export default manage;
